import * as React from 'react';

function SvgPriceTag(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { fill: "currentColor", d: "M19.503 8.997V4.19a1.747 1.747 0 00-1.747-1.75h-4.803c-.315 0-.617.125-.84.347l-9.602 9.6a1.752 1.752 0 000 2.474l4.571 4.57a1.752 1.752 0 002.475 0l9.598-9.595c.222-.223.347-.525.348-.84zm-3.75-1.555a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5z" }),
        React.createElement("path", { fill: "currentColor", d: "M21.376 4.316a.625.625 0 00-.625.626v4.976l-10.209 10.21a.626.626 0 10.884.883l10.236-10.236a1.165 1.165 0 00.34-.833v-5a.625.625 0 00-.626-.626z" })));
}

export default SvgPriceTag;
